import styles from './AddVaccinationNote.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';

import TextArea from '../../components/TextArea/TextArea';
import { useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';

const AddVaccinationNote = () => {
  const dispatch = useDispatch();
  const handleSave = () => {
    console.log('remainder sent:');
    dispatch(closeModal());
  };

  const handleClose = () => {
    dispatch(closeModal());
    console.log('remainder not sent');
  };

  const handleCancel = () => {
    dispatch(closeModal());
    console.log('remainder not sent');
  };

  const [vaccinationNote, setVaccinationNote] = useState('');

  return (
    <div className={styles.cardContainer}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FaFileAlt />}
          heading="Vaccination Note"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={handleClose} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        <TextArea
          label="Add Vaccination"
          value={vaccinationNote}
          onChange={(e) => setVaccinationNote(e.target.value)}
          placeholder="Enter Note"
          required
        />
        <div className={styles.actions}>
          <SaveAndCancel
            onSave={handleSave}
            onCancel={handleCancel}
            saveLabel="No"
            cancelLabel="Yes"
          />
        </div>
      </div>
    </div>
  );
};

export default AddVaccinationNote;
